var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82564 0.700399C9.03718 0.488865 9.38014 0.488865 9.59168 0.700399L11.7583 2.86707C11.9699 3.0786 11.9699 3.42156 11.7583 3.6331L9.59168 5.79976C9.38014 6.0113 9.03718 6.0113 8.82564 5.79976C8.61411 5.58823 8.61411 5.24527 8.82564 5.03373L10.6093 3.25008L8.82564 1.46643C8.61411 1.2549 8.61411 0.911933 8.82564 0.700399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79134 3.79159C3.36036 3.79159 2.94704 3.96279 2.64229 4.26754C2.33755 4.57228 2.16634 4.98561 2.16634 5.41659V5.95825C2.16634 6.25741 1.92383 6.49992 1.62467 6.49992C1.32552 6.49992 1.08301 6.25741 1.08301 5.95825V5.41659C1.08301 4.69829 1.36835 4.00942 1.87626 3.5015C2.38417 2.99359 3.07305 2.70825 3.79134 2.70825H11.3747C11.6738 2.70825 11.9163 2.95076 11.9163 3.24992C11.9163 3.54907 11.6738 3.79159 11.3747 3.79159H3.79134Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17436 7.2004C4.38589 7.41193 4.38589 7.7549 4.17436 7.96643L2.39071 9.75008L4.17436 11.5337C4.38589 11.7453 4.38589 12.0882 4.17436 12.2998C3.96282 12.5113 3.61986 12.5113 3.40833 12.2998L1.24166 10.1331C1.03012 9.92156 1.03012 9.5786 1.24166 9.36707L3.40833 7.2004C3.61986 6.98886 3.96282 6.98886 4.17436 7.2004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3747 6.5C11.6738 6.5 11.9163 6.74251 11.9163 7.04167V7.58333C11.9163 8.30163 11.631 8.9905 11.1231 9.49841C10.6152 10.0063 9.9263 10.2917 9.20801 10.2917H1.62467C1.32552 10.2917 1.08301 10.0492 1.08301 9.75C1.08301 9.45085 1.32552 9.20833 1.62467 9.20833H9.20801C9.63898 9.20833 10.0523 9.03713 10.3571 8.73238C10.6618 8.42763 10.833 8.01431 10.833 7.58333V7.04167C10.833 6.74251 11.0755 6.5 11.3747 6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.ecdf6475b3aac34aa7572e2a055b05c7.svg";
export { ForwardRef as ReactComponent };